module.exports = __webpack_public_path__ + "img/logo.cc2804a5.png";